import React, { useEffect } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";
import ErrorBoundary from "./components/ErrorBoundary";
import { getLogoUrl } from "./services/logoService";

// Patch ErrorBoundary.prototype.componentDidCatch SYNCHRONOUSLY at module load
// Intercept BEFORE the original so 'error' is always a proper Error object
// when the original method does error.__ErrorBoundary = true
(function patchErrorBoundary() {
  if (ErrorBoundary && ErrorBoundary?.prototype && !ErrorBoundary?.__patched) {
    const originalCDC = ErrorBoundary?.prototype?.componentDidCatch;
    ErrorBoundary.prototype.componentDidCatch = function(error, errorInfo) {
      // Normalize non-object / undefined thrown values BEFORE original runs
      if (!error || typeof error !== 'object') {
        error = new Error(String(error ?? 'Unknown error'));
      }
      if (typeof originalCDC === 'function') {
        return originalCDC?.call(this, error, errorInfo);
      }
    };
    ErrorBoundary.__patched = true;
  }
})();

function App() {
  useEffect(() => {
    const applyLogoAsIcons = async () => {
      const logoUrl = await getLogoUrl();
      if (!logoUrl) return;

      // Update favicon
      const favicon = document.querySelector("link[rel='icon']");
      if (favicon) {
        favicon.href = logoUrl;
      } else {
        const newFavicon = document.createElement("link");
        newFavicon.rel = "icon";
        newFavicon.href = logoUrl;
        document.head?.appendChild(newFavicon);
      }

      // Update apple-touch-icon
      const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
      if (appleIcon) {
        appleIcon.href = logoUrl;
      } else {
        const newAppleIcon = document.createElement("link");
        newAppleIcon.rel = "apple-touch-icon";
        newAppleIcon.href = logoUrl;
        document.head?.appendChild(newAppleIcon);
      }

      // Update msapplication tile image
      const msTile = document.querySelector("meta[name='msapplication-TileImage']");
      if (msTile) {
        msTile.content = logoUrl;
      }
    };

    applyLogoAsIcons();
  }, []);

  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}

export default App;
